$(document).ready(function () {
    var brand = '';
    var installments = '';
    var amount = '0.0';
    var numeroCartao = $('.pagseguro-transparente #cardNumber');

    if(typeof PagSeguroDirectPayment == "undefined")
        return false;

    $.ajax({url: './pagamento/pagseguro_token',dataType: 'json'}).done(function (response) {
        console.log(response);
        var token = response.token;
        $('[name=sessionId]').val(token);
        PagSeguroDirectPayment.setSessionId(token);
    });

    PagSeguroDirectPayment.onSenderHashReady(function (response) {
        if (response.status == 'error') {
            console.log(response.message);
            return false;
        }
        var hash = response.senderHash; //Hash estará disponível nesta variável.
        $('[name=senderhash]').val(hash);
    });

    $('.metodo-pagamento.pagseguro-transparente #securityCode').on('change paste keyup', function () {
        if (valid_credit_card(numeroCartao.val()) || numeroCartao.val().length == 0) {
            numeroCartao.removeClass('erro-cartao');

            PagSeguroDirectPayment.createCardToken({
                cardNumber: numeroCartao.val(), // Número do cartão de crédito
                brand: brand.name, // Bandeira do cartão
                cvv: $('.pagseguro-transparente #securityCode').val(), // CVV do cartão
                expirationMonth: $('.pagseguro-transparente #cardExpirationMonth').val(), // Mês da expiração do cartão
                expirationYear: $('.pagseguro-transparente #cardExpirationYear').val(), // Ano da expiração do cartão, é necessário os 4 dígitos.
                success: function (response) {
                    $('[name=tkncc]').val(response.card.token);
                    console.log('Valido!');
                },
                error: function (response) {
                    console.log(response)
                },
                complete: function (response) {
                    // Callback para todas chamadas.
                }
            });

        } else {
            if (!numeroCartao.hasClass('erro-cartao')) {
                numeroCartao.addClass('erro-cartao');
            }
        }
    });

    $('#pagamento').submit(function (e) {
        if ((!$('[name=senderhash]').val().length || !$('[name=tkncc]').val().length) && $('.metodo-pagamento.pagseguro-transparente.is-active').length)
            e.preventDefault();
    });


    $('.metodo-pagamento.pagseguro-transparente #cardNumber').on('change paste keyup', function () {
        console.log(numeroCartao.val());
        if (numeroCartao.val().length >= 6) {
            PagSeguroDirectPayment.getBrand({
                cardBin: numeroCartao.val().slice(0, 6),
                success: function (response) {
                    console.log(response);
                    $('.pagseguro-transparente #securityCode').attr('maxlength', response.brand.cvvSize);
                    brand = response.brand;
                    amount = $('.pagseguro-transparente #amount').val();
                    $('.card-logo').attr('class', 'card-logo ' + brand.name);
                    setTimeout(function () {
                        PagSeguroDirectPayment.getInstallments({
                            amount: amount,
                            brand: brand.name,
                            success: function (response) {
                                console.log(response);
                                installments = response.installments[Object.keys(response.installments)[0]];
                                console.log(installments);
                                $('.pagseguro-transparente #installments').empty();
                                installments.forEach(function (parcela, index) {
                                    $('.pagseguro-transparente #installments').append("<option data-valor='" + parcela.installmentAmount + "' value='" + String(parcela.quantity + "_" + parcela.installmentAmount) + "'> " + parcela.quantity + "x R$ " + parcela.installmentAmount.toFixed(2) + " = R$ " + parcela.totalAmount.toFixed(2) + " </option>");
                                    var novoTexto = $('.pagseguro-transparente #installments option').last().text().replace('.', ',');
                                    $('.pagseguro-transparente #installments option').last().text(novoTexto);
                                });
                            },
                            error: function (response) {
                                // callback para chamadas que falharam.
                            },
                            complete: function (response) {
                                // Callback para todas chamadas.
                            }
                        });
                    }, 300);

                },
                error: function (response) {
                    //tratamento do erro
                },
                complete: function (response) {
                    //tratamento comum para todas chamadas
                }
            });
        }
    });
});

$('.btn-finish').click(function (e) {
    if ($('.metodo-pagamento.pagseguro-transparente.is-active').length) {
        $('.pagseguro-transparente input:not([style="display:none;"], .no-needed )').each(function () {
            $(this).val().length < 1 ? $(this).addClass('erro-cartao') : ($(this).removeClass('erro-cartao'));
            $(this).attr('type') == 'hidden' ? $(this).removeClass('erro-cartao') : '';
        });

        $('.pagseguro-transparente select:not(#installments)').each(function () {
            $(this).val().length <= 0 ? $(this).addClass('erro-cartao') : $(this).removeClass('erro-cartao');
        });
        if (!$('.erro-cartao').length) {
            $('#pagamento').submit();
        } else {
            e.preventDefault();
            alert('Preencha todos os campos para Finalizar a Compra');
        }
    }
});


//LUNH
function valid_credit_card(value) {
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n),
            nDigit = parseInt(cDigit, 10);

        if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) == 0;
}